module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/map-marked.svg?1fc9411f9cc6c20a5678f1876dd70c14";